import React, { Component } from 'react'
import request from 'superagent'
import accounting from 'accounting'

import { fetch, store } from '../store/settings'
import Settings from './settings'
import { track } from '../actions/analytic'

class Cart extends Component {

  state = {
    loading: false,
    showSettings: false,
    name: 'Budi',
    phone: '081808466410',
    email: 'budi@utomo.com',
    address: 'MidPlaza 2, 4th Floor Jl.Jend.Sudirman Kav.10-11',
    city: 'Jakarta',
    postalCode: '10220',
    settings: fetch(),
    price: 0
  }

  componentWillReceiveProps = () => {
    if (this.props.items && this.props.items.length > 0) {
      this.setState({ price: this.props.items[0].price });
    }
  }

  _onResult = (type, result) => {
    track('Pay', 'done', type, result)

    this._onCancel()
    this.props.onResult({type: type})
  }

  _onSettingsStart = (settings, save) => {
    if (save) {
      store(settings)
    }
    this.setState({settings: settings}, () => {
      if (settings.chargeSettings.use_merchant_keys && settings.chargeSettings.client_key) {
        snap.reset()
        snap.init(settings.chargeSettings.client_key)
      }
      setTimeout(() => {
        this._onCheckout()
      }, 200)
    })
  }

  _onCheckout = () => {

    if (this.state.loading)
      return

    this.setState({loading: true})
    track('Pay', 'checkout')

    snap.show()

    var baseUrl = document.querySelector('head base').getAttribute('href')
    var chargeUrl = baseUrl + ((baseUrl !== '/') ? '/' : '') + 'charge'
    var csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

    const total = this.props.items.reduce((total, item) => {
      return total + Number(item.price)
    }, 0)

    request
      .post(chargeUrl)
      .send({
        _csrf: csrfToken,
        customer_details: {
          first_name: this.state.name,
          email: this.state.email,
          phone: this.state.phone,
          shipping_address: {
            first_name: this.state.name,
            email: this.state.email,
            phone: this.state.phone,
            address: this.state.address,
            city: this.state.city,
            postal_code: this.state.postalCode,
            country_code: 'IDN'
          }
        },
        settings: this.state.settings.feature === 'custom' ? this.state.settings.chargeSettings : {},
        gross_amount: total
      })
      .end((err, res) => {

        if (err || !res || !res.body || !res.body.token) {
          snap.hide()
          this._onResult('error', err || res.body)
          return
        }

        if (!this.state.settings.chargeSettings.is_snap_pop_up) {
          window.location = res.body.redirect_url;
          return;
        }

        snap.pay(res.body.token, {
          onSuccess: (result) => {
            this._onResult('success', result)
          },
          onPending: (result) => {
            this._onResult(result.payment_type == 'credit_card' ? 'success' : 'pending', result)
          },
          onError: (error) => {
            this._onResult('error', error)
          },
          onClose: () => {
            track('Pay', 'cancel')
            this.props.onCancel()
          },

          isDemoMode: true
        })

        this.setState({loading: false})
      })

    if (this.props.onCheckout) {
      this.props.onCheckout()
    }
  }

  _onCancel = () => {
    this.setState({loading: false})
    this.props.onCancel()
  }

  _onSettings = () => {
    this.props.onSettings(true)
    this.setState({showSettings: true})
  }

  _onSettingsCancel = () => {
    this.props.onSettings(false)
    this.setState({showSettings: false})
  }

  _onInputChange = () => {
    this.setState({
      phone: this.refs.phone.value,
      email: this.refs.email.value,
      name: this.refs.name.value,
      city: this.refs.city.value,
      postalCode: this.refs.postal_code.value,
      address: this.refs.address.value
    })
    const price = Number(this.refs.price.value)
    if(Number.isInteger(price) && price > 0) {
      this.props.onPriceChange(price);
      this.setState({ price })
    }
  }

  render () {
    let items = this.props.items.map((item) => {
      return (
        <tr key={item.id} className="table-content">
          <td>{item.title}</td>
          <td>&times; 1</td>
          <td className="input text-right"><input className="text-right" type="number" ref="price" onChange={this._onInputChange} value={this.state.price}/></td>
        </tr>
      )
    })

    let total = this.props.items.reduce((total, item) => {
      return total + item.price
    }, 0)

    let buttonContent = this.state.loading ? (
      <img alt="loading..." src="/images/load.gif"/>
    ) : 'CHECKOUT'

    return (
      <div className={this.props.className}>
        <div className="cart-inner">
          <div className="cart-head">
            Shopping Cart &nbsp;
            <span className="label label-primary">1</span>
          </div>
          <div className="cart-section">
            <table className="table">
              <thead>
              <tr>
                <th>Product</th>
                <th>Qty</th>
                <th className="amount">Amount (Rp)</th>
              </tr>
              </thead>
              <tbody>
              {items}
              <tr className="total">
                <td className="empty"></td>
                <td className="total">Total</td>
                <td className="amount">{accounting.formatMoney(total, '', '0')}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div className="cart-head">
            Customer Details
          </div>
          <div className="cart-section">
            <table className="table">
              <tbody>
              <tr className="table-content">
                <td className="input-label">Name</td>
                <td className="input" colSpan="2"><input type="text" ref="name" onChange={this._onInputChange}
                                                         value={this.state.name}/></td>
              </tr>
              <tr className="table-content">
                <td className="input-label">Email</td>
                <td className="input" colSpan="2"><input type="email" ref="email" onChange={this._onInputChange}
                                                         value={this.state.email}/></td>
              </tr>
              <tr className="table-content">
                <td className="input-label">Phone no</td>
                <td className="input" colSpan="2"><input type="text" ref="phone" onChange={this._onInputChange}
                                                         value={this.state.phone}/></td>
              </tr>
              <tr className="table-content">
                <td className="input-label">City</td>
                <td className="input" colSpan="2"><input type="text" ref="city" onChange={this._onInputChange}
                                                         value={this.state.city}/></td>
              </tr>
              <tr className="table-content">
                <td className="input-label">Address</td>
                <td className="input" colSpan="2">
                  <textarea ref="address" onChange={this._onInputChange}>
                    {this.state.address}
                  </textarea>
                </td>
              </tr>
              <tr className="table-content">
                <td className="input-label">Postal Code</td>
                <td className="input" colSpan="2"><input type="text" ref="postal_code" onChange={this._onInputChange}
                                                         value={this.state.postalCode}/></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="cart-action">
          <div className="cart-checkout" onClick={this._onCheckout}>
            {buttonContent}
          </div>
          <div className="cart-checkout-settings" onClick={this._onSettings}>
            <img src="images/advanced-preference-icon.png" alt="⚙" width="16"/>
          </div>
          <div className="cancel-btn" onClick={this._onCancel}>
            cancel
          </div>
        </div>
        <Settings settings={this.state.settings} show={this.state.showSettings} onStart={this._onSettingsStart}
                  onCancel={this._onSettingsCancel}/>
      </div>
    )
  }
}

export default Cart



// WEBPACK FOOTER //
// ./src/js/components/cart.jsx